import React, { useEffect } from "react";
import { Item } from "../../../../store/viewmodels/ItemViewModel";
import { shuffle } from "../../../../utils/ItemServices";
import CombineCard from "./CombineCard";

interface CombineCardsProps {
    item: Item,
    answer: string,
    setAnswer: React.Dispatch<React.SetStateAction<any[]>>,
    setClear: React.Dispatch<React.SetStateAction<boolean>>,
    setFirstRow: React.Dispatch<React.SetStateAction<any[]>>
    clear: boolean
}

const emptyItem: Item = {
    id: -1,
    name: "",
    type: "",
    settings: {},
    files: [],
    content: "",
    child_items: [],
    correct: "",
    index: NaN
}

function CombineCards(props: CombineCardsProps): JSX.Element {
    const [selectedCards, setSelectedCards] = React.useState([] as { row: string, index: number }[]);
    const [firstRow, setFirstR] = React.useState([] as any[]);
    const [secondRow, setSecondRow] = React.useState([] as any[]);
    const [thirdRow, setThirdRow] = React.useState([] as any[]);
    const [updated, setUpdated] = React.useState(false);

    useEffect(() => {
        start(props.item, setFirstR, setSecondRow, setThirdRow);
    }, [props.item]);

    useEffect(() => {
        if (props.clear === true) {
            start(props.item, setFirstR, setSecondRow, setThirdRow);
            props.setClear(false);
            setSelectedCards([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.clear])

    useEffect(() => {
        if (selectedCards.length >= 2) {
            if (selectedCards[0].row === selectedCards[1].row) {
                let row = selectedCards[0].row;
                let rowArray = selectedCards[0].row === "secondRow" ? Array.from(secondRow) : Array.from(thirdRow);
                let help = rowArray[selectedCards[0].index];

                rowArray[selectedCards[0].index] = rowArray[selectedCards[1].index];
                rowArray[selectedCards[1].index] = help;

                switch (row) {
                    case "secondRow": {
                        setSecondRow(rowArray);
                        clearAll();
                        break;
                    }
                    case "thirdRow": {
                        setThirdRow(rowArray);
                        clearAll();
                        break;
                    }
                    default: break;
                }
            } else {
                switch (selectedCards[0].row) {
                    case "secondRow": {
                        switchPlaces(selectedCards[0].index, selectedCards[1].index);
                        break;
                    }
                    case "thirdRow": {
                        switchPlaces(selectedCards[1].index, selectedCards[0].index);
                        break;
                    }
                    default: break;
                }
            }
        } 
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCards]);

    function switchPlaces(index_a: number, index_b: number) {
        let row2 = Array.from(secondRow);
        let row3 = Array.from(thirdRow);

        let help = row2[index_a];
        row2[index_a] = row3[index_b];
        row3[index_b] = help;

        setSecondRow(row2);
        setThirdRow(row3);
        clearAll();
    }

    useEffect(() => {
        let answers = [] as any[];
        for (let i: number = 0; i < secondRow.length; i++) {
            if (secondRow[i].item.id !== -1) {
                answers.push(secondRow[i]);
            }
        }

        props.setAnswer(answers);
        props.setFirstRow(firstRow);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [secondRow])

    function clearAll() {
        setSelectedCards([] as { row: string, index: number }[]);
        setUpdated(!updated);
    }

    let gaps = " gap-0 md:gap-1 lg:gap-2 2xl:gap-4 8xl:gap-6"

    let cards = (
        <div className={"grid grid-rows-3" + gaps}>
            <div className={"flex " + gaps}>
                {firstRow.map((card, index) => (
                    <CombineCard
                        key={'firstCard' + card.item.id + index}
                        index={index}
                        place={"firstRow"}
                        file={card.file}
                        itemid={card.item.id}
                        setSelectedCards={setSelectedCards}
                        selectedCards={selectedCards}
                        updated={updated}
                    />
                ))}
            </div>
            <div className={"flex " + gaps}>
                {secondRow.map((card, index) => (
                    <div className="w-full" key={"SecondOfPair" + index}>
                        <CombineCard
                            key={'emptyCards' + card.item.id + index}
                            index={index}
                            place={"secondRow"}
                            itemid={card.item.id}
                            file={card.file}
                            setSelectedCards={setSelectedCards}
                            selectedCards={selectedCards}
                            updated={updated}
                        />
                    </div>
                ))}
            </div>
            <div className={"flex " + gaps}>
                {thirdRow.map((card, index) => (
                    <CombineCard
                        key={'secondCard' + card.item.id + index}
                        index={index}
                        place={"thirdRow"}
                        itemid={card.item.id}
                        file={card.file}
                        setSelectedCards={setSelectedCards}
                        selectedCards={selectedCards}
                        updated={updated}
                    />
                ))}
            </div>
        </div>
    );

    return cards;
}

function start(item: Item, setFirstRow: React.Dispatch<React.SetStateAction<any[]>>, setSecondRow: React.Dispatch<React.SetStateAction<any[]>>, setThirdRow: React.Dispatch<React.SetStateAction<any[]>>) {
    let allItems = item.child_items;
    let combineFirstCards: any[] = [];
    let combineSecondCards: any[] = [];
    let emptyCards: any[] = [];

    allItems.forEach(i => {
        const firstCard = {
            item: i,
            file: i.files[0],
        }

        const secondCard = {
            item: i,
            file: i.files[1],
        }

        const emptyCard = {
            item: emptyItem,
            file: undefined,
        }

        combineFirstCards.push(firstCard);
        combineSecondCards.push(secondCard);
        emptyCards.push(emptyCard);
    });

    setFirstRow(shuffle(combineFirstCards));
    setSecondRow(emptyCards);
    setThirdRow(shuffle(combineSecondCards));
}

export default CombineCards;